/**
 * @description 互动模块弹窗的层级
 */
class ZIndexServer {
  constructor() {
    // 自增z-index
    this.zIndex = 1100;
    this.state = {
      zIndexMap: {
        'topChatMsg': 800, // 聊天室顶部
        'giftPay': 1018, // 礼物支付弹窗
        'lottery': 1021, // 抽奖弹窗
        'redPacket': 1022, // 红包弹窗 暂时和口令共用
        'reward': 1023, // 打赏弹窗
        'questionnaire': 1027, // 问卷弹窗
        'signIn': 1028, // 签到弹窗
        'examList': 1030, // 快问快答-列表弹窗
        'examAnswer': 1032, // 快问快答-答题面板/成绩面板弹窗
        'examRank': 1034, // 快问快答-排行榜弹窗
        'pushCard': 1036, // 推屏卡片
        'inviteCard': 1038, // 邀请卡
        'interactReward': 1040,// 互动有礼
        'watchGift': 1042, // 观看有礼主弹窗
        'cashRedpacket': 1043, // 现金红包主弹窗
        'watchGiftJackpot': 1044, // 观看有礼奖池弹窗
        'mallReward': 1046, // 商城奖励
        'punch': 1049, // 打卡弹窗
        "product": 1050, // 商品弹窗
      }
    }
  }
  setDialogZIndex(type) {
    // 每次加3， 因为van-popup每次在当前基础上遮罩+1,包裹容器+2，否则会出现z-index会重复
    this.zIndex = this.zIndex + 3;
    this.state.zIndexMap[type] = this.zIndex;
  }
}

export default function useZIndexServer() {
  if (!ZIndexServer.instance) {
    ZIndexServer.instance = new ZIndexServer()
  }
  return ZIndexServer.instance
}